import type { Action } from 'redux';
import type { IAdLink } from '../../../../../../shared/types';
import NotificationActions from '../../../../main/actions/NotificationActions';
import { AdLinkEditorService } from '../../../../main/services/AdLinkEditorService/AdLinkEditorService';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const DeleteAdLink = new ReduxAsyncAction<'DELETE_AD_LINK', string, IAdLink>('DELETE_AD_LINK');

DeleteAdLink.registerRequest(async (adLinkId: string): Promise<IAdLink> => {
  try {
    const { data } = await dash_api.delete(`/v1/linkhub/ad/${adLinkId}`);

    NotificationActions.showNotification(`Link '${data.data.$link_title}' deleted`, 'success');

    return AdLinkEditorService.getAdLinkPayload(data);
  } catch (error) {
    NotificationActions.showNotification('Failed to delete ad link.', 'error');

    throw error;
  }
});

export const DELETE_AD_LINK = DeleteAdLink.actionNamespaceConstants;
export const deleteAdLink = DeleteAdLink.request;

export type DeleteAdLinkResponseAction = Action<typeof DELETE_AD_LINK.response> & {
  data: IAdLink;
};
